import { render } from "./Image.vue?vue&type=template&id=0c435cf2&bindings={\"classVal\":\"props\",\"titleVal\":\"props\",\"srcVal\":\"props\",\"idVal\":\"props\",\"resolve_img_url\":\"options\"}"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"

import "./Image.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script